var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: "foreSpeak(PH)", isShowFollow: false },
              on: { opened: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c(
              "div",
              { staticClass: "filter-container-content" },
              [
                _c(
                  "el-form",
                  { ref: "form", attrs: { model: _vm.form } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "vvLBlNo",
                                  label: _vm.$t(
                                    "blExchangeAppointment.voyageNoBlNo"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    disabled: true,
                                    type: "textarea",
                                    autosize: { minRows: 2, maxRows: 4 },
                                  },
                                  model: {
                                    value: _vm.vvLBlNo,
                                    callback: function ($$v) {
                                      _vm.vvLBlNo = $$v
                                    },
                                    expression: "vvLBlNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "forespeakStatus",
                                  label: _vm.$t(
                                    "blExchangeAppointment.forespeakStatus"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      disabled: true,
                                      placeholder: _vm.$t(
                                        "blExchangeAppointment.select"
                                      ),
                                    },
                                    model: {
                                      value: _vm.forespeakStatus,
                                      callback: function ($$v) {
                                        _vm.forespeakStatus = $$v
                                      },
                                      expression: "forespeakStatus",
                                    },
                                  },
                                  _vm._l(
                                    _vm.forespeakStatusList,
                                    function (item) {
                                      return _c("el-option", {
                                        key: item.codeValue,
                                        attrs: {
                                          value: Number(item.codeValue),
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "ownerType",
                                  label: _vm.$t(
                                    "blExchangeAppointment.ownerType"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    model: {
                                      value: _vm.form.ownerType,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "ownerType",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "form.ownerType",
                                    },
                                  },
                                  _vm._l(
                                    _vm.ecmNgbEdoOwnerType,
                                    function (item) {
                                      return _c("el-option", {
                                        directives: [
                                          { name: "trim", rawName: "v-trim" },
                                        ],
                                        key: item.codeValue,
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "blExchangeAppointment.select"
                                          ),
                                          value: item.codeValue,
                                          label:
                                            _vm.language === "zh"
                                              ? item.displayValueCn
                                              : item.displayValue,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "identifier",
                                  label: _vm.$t(
                                    "blExchangeAppointment.identifier"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 50,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.identifier,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "identifier", $$v)
                                    },
                                    expression: "form.identifier",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 14 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "consigneeName",
                                  label: _vm.$t(
                                    "blExchangeAppointment.consigneeName"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 500,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.consigneeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "consigneeName", $$v)
                                    },
                                    expression: "form.consigneeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  prop: "consigneeAddress",
                                  label: _vm.$t(
                                    "blExchangeAppointment.consigneeAddress"
                                  ),
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: 500,
                                    placeholder: _vm.$t(
                                      "blExchangeAppointment.pleaseInput"
                                    ),
                                  },
                                  model: {
                                    value: _vm.form.consigneeAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "consigneeAddress",
                                        $$v
                                      )
                                    },
                                    expression: "form.consigneeAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { staticClass: "item-button" },
                      [
                        _vm.edoCreditId
                          ? _c(
                              "el-button",
                              {
                                staticClass: "btn-info-primary",
                                on: { click: _vm.handleCancel },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("btn.cancelAppointment")) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            on: { click: _vm.handleNext },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("btn.nextStep")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }